import { z } from 'zod';
import { defineTool } from './types.ts';

export const choiceCard = defineTool({
  name: 'render_choices',
  description:
    'Show tappable options when the user must pick one path (e.g. which interview round to practise). Ask the question out loud too. The user\'s pick arrives as a text message starting with "[picked]".',
  params: z.object({
    question: z.string().min(1).max(140),
    options: z
      .array(
        z.object({
          id: z.string().min(1).max(40),
          label: z.string().min(1).max(60),
          hint: z.string().max(100).optional(),
        }),
      )
      .min(2)
      .max(5),
  }),
  execution: 'client',
  behavior: 'BLOCKING',
  fixtures: [
    {
      name: 'rounds',
      params: {
        question: 'Which round worries you most?',
        options: [
          { id: 'behavioral', label: 'Behavioral', hint: 'Stories, leadership, conflict' },
          { id: 'product-sense', label: 'Product sense', hint: 'Design and prioritisation' },
          { id: 'analytical', label: 'Analytical', hint: 'Metrics and estimation' },
        ],
      },
    },
  ],
});
